/* Built In Imports */
import NextLink from 'next/link';
/* External Imports */
import { Box, Flex, Image, Link, Text } from '@chakra-ui/react';
import Slider from 'react-slick';
// import { LazyLoadComponent } from 'react-lazy-load-image-component';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import config from '@config';
import { refineUrlDomain } from '@components/Utility/utils';
import PartnerWithusForm from '@landing_pages/csr/components/PartnerWithusForm';

/* Services */
/* Styles */
import { useState } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 * Renders VolunteerSharingTopSliderGroup Component
 *
 * @param {object} sectionContent - Data from api
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @returns
 */

const SGXSliderBanner = ({
  sectionContent,
  region,
  language,
  formElement
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const [textIndex, setTextIndex] = useState(0);
  const styles = {
    default: 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
    'without-bottom-angle': '',
    '': 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
  };

  const handleButtonClick = (event) => {
    event.preventDefault();
    openModal();
  };

  const NextArrow = props => {
    const { onClick } = props;
    return (
      <Box
        pos="absolute"
        textAlign={'center'}
        top={{ base: '25%', md: '45%', xl: '30%', '2xl': '45%' }}
        zIndex="15"
        cursor="pointer"
        bgColor="#fff"
        border="0"
        borderRadius="32px"
        w={{xl:'69.29px', '2xl':"92.39px"}}
        h={{xl: '53.2px', '2xl':"76.57px"}}
        bgPos="center"
        bgRepeat="no-repeat"
        color="transparent"
        bgImage={`url(${config.staticPath}/d/46272/1711128888-chevron-right.svg)`}
        right={{ base: '2%', xl: '60px', '2xl': '84px' }}
        bgSize="26px"
        onClick={onClick}
        display={{ base: 'none', md: 'block' }}
        boxShadow="0 0 15px 0 rgb(0 0 0 / 30%)"
      ></Box>
    );
  };

  const PrevArrow = props => {
    const { onClick } = props;
    return (
      <Box
        pos="absolute"
        top={{ base: '25%', md: '45%', xl: '30%', '2xl': '45%' }}
        zIndex="15"
        cursor="pointer"
        bgSize="26px"
        bgColor="#fff"
        border="0"
        borderRadius="32px"
        w={{xl:'69.29px', '2xl':"92.39px"}}
        h={{xl: '53.2px', '2xl':"76.57px"}}
        bgPos="center"
        bgRepeat="no-repeat"
        color="transparent"
        bgImage={`url(${config.staticPath}/d/46272/1711128885-chevron-left.svg)`}
        left={{ base: '2%', xl: '60px', '2xl': '84px' }}
        onClick={onClick}
        display={{ base: 'none', md: 'block' }}
        boxShadow="0 0 15px 0 rgb(0 0 0 / 30%)"
      />
    );
  };

  const settings = {
    dots: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 834,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    beforeChange: (current, next) => setTextIndex(next),    
    appendDots: dots => (
      <Flex display={{base: 'flex', md: 'none'}} height="40px" position="relative" mt={'-60px'}>
          <Flex
              marginRight="auto"
              marginLeft="auto"
              width="40px"
              // mt="20px"
              justifyContent="space-between"
          >
              {dots.map(dot => {
                  const button = dot.props.children;
                  return (
                      <button
                          key={dot.key}
                          style={{
                              display: 'flex', // Ensure the button content aligns properly
                              justifyContent: 'center', // Center the content horizontally
                              alignItems: 'center', // Center the content vertically
                              width: '8px',
                              height: '8px',
                              border: 'none', // Remove default browser border styles
                              padding: '0', // Ensure no extra padding
                              margin: '0', // Avoid unwanted margins
                              borderRadius: '50%',
                              boxSizing: 'border-box', // Ensure padding and borders are included in dimensions
                              backgroundColor:
                                textIndex.toString() === dot.key ? '#BB3E03' : '#FFFFFF',
                              cursor: 'pointer',
                          }}
                          onClick={e => {
                              button.props.onClick(e);
                              setTextIndex(dot.key);
                          }}
                      >
                        <div style={{width: '8px', height: '8px', bgColor: textIndex.toString() === dot.key ? '#BB3E03' : '#FFFFFF'}}/>
                          {/* <SliderDots
                              color={textIndex.toString() === dot.key ? '#000641' : '#DDDDDD'}
                              style={{
                                  width: '100%',
                                  height: '100%',
                              }}
                          /> */}
                      </button>
                  );
              })}
          </Flex>
      </Flex>
  ),
    customPaging: function (i) {
      return (
        <Text
          cursor="pointer"
          display="inline-block"
          w="10px"
          h="10px"
          m="0px 8px"
          // mt={'10rem'}
          bgColor="#cf4520"
          borderRadius="50%"
        ></Text>
      );
    },
  };
  return (
    <>
      <Box
        pos={'relative'}
        height={{ base: 'auto', md: '640px' }}
      >
        <Slider {...settings}>
          {sectionContent &&
            sectionContent?.slides?.length > 0 &&
            sectionContent?.slides?.map((slide, index) => {
              return (
                <Box height={'auto'} w={'100%'} pos="relative" key={index}>
                  <Box
                    h={{
                      base: "749px",
                      md: '640px',
                    }}
                    bgColor={{
                      base: 'transparent;',
                      sm: 'transparent',
                    }}
                    backgroundRepeat="no-repeat"
                    backgroundSize={{base:'cover', 'xl': "contain", "2xl": 'cover'}}
                    // backgroundPosition={{
                    //   base: '45%',
                    //   sm: '45%',
                    //   lg: 'top center',
                    //   xl: '0',
                    // }}
                    backgroundImage={{
                      md: slide?.desktopImage?.url,
                      base: slide?.mobileImage?.url || slide?.desktopImage?.url,
                    }}
                    // mb={{ base: '0', xl: '0' }}
                    // clipPath={styles[slide.style]}
                  >
                  </Box>
                </Box>
              );
            })}
        </Slider>
      </Box>
    </>
  );
};

export default SGXSliderBanner;